import PropTypes from 'prop-types'
import React from 'react'
import css from './LoggedOutHeader.module.css'
import segmentIconSvg from './segment-icon.svg'

const LoggedOutHeader = ({ title }) => (
  <header className={css.main}>
    <div className={css.logo}>
      <img src={segmentIconSvg} alt="Segment" />
    </div>
    <h1>{title}</h1>
  </header>
)

LoggedOutHeader.propTypes = {
  title: PropTypes.string
}

export default LoggedOutHeader
